var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"informations-container"},[_c('Generalites'),_c('ContexteGeopolitique'),_c('SituationPolitique'),_c('RisquesLocaux'),_c('CartographieRisques'),_c('SanitaireSante'),_c('Recommandations')],1)}
var staticRenderFns = []

export { render, staticRenderFns }